/**
 * 关于
 */
import { ABOUT } from '../types';

export default {
    name: `${ABOUT}`,
    path: '/about',
    component: () => import(/* webpackChunkName: 'about' */ '@/views/about/'),
    redirect: { name: `${ABOUT}Index` },
    meta: {
        title: '关于',
        // 页签缓存的滚动条位置
        savedPosition: { x: 0, y: 0 },

        // 取消该页签缓存，每次跳转到该页签都会刷新
        noCache: true,
    },
    children: [
        {
            name: `${ABOUT}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'about' */ '@/views/about/home/Home.vue'),
        },
        {
            name: `${ABOUT}Detail`,
            path: 'detail',
            component: () => import(/* webpackChunkName: 'about' */ '@/views/about/detail/Detail.vue'),
        },
    ],
};
